const isMobileAppEmbed = query => query?.embedded === 'mobileapp' || query?.embedded === 'genericmobileapp'

/**
 * `profile-password?forced=true` est la variante que l'app mobile charge en
 * iframe pour le renouvellement forcé (voir PasswordSetting.vue). Réservée à
 * cet usage : accédée sans le paramètre `embedded` attestant du contexte
 * mobile, elle redirige vers `home` - le dialog bloquant global
 * (`PasswordExpiredDialog`, monté depuis App.vue) y prend de toute façon le
 * relais si le mot de passe est réellement expiré.
 */
export default function (to) {
	let result = true
	if (to.name === 'profile-password' && to.query.forced === 'true' && !isMobileAppEmbed(to.query)) {
		result = { name: 'home' }
	}
	return result
}
